/**
 * 特定の条件のみに実行したいときに利用します。
 *
 * @param obj mtappVarsで定義されているプロパティと値をセット
 * @param callback 第一引数の値が全てが一致する場合に実行する関数
 */
export function condition(obj, callback) {
    const checkProperty = (path, expectedValue) => {
        let target = window.mtappVars;
        const deepProps = path.split(/\./);

        for (const prop of deepProps) {
            if (typeof target[prop] === 'undefined') {
                return false;
            }
            target = target[prop];
        }

        return target === expectedValue;
    };

    for (const prop in obj) {
        if (!checkProperty(prop, obj[prop])) {
            return;
        }
    }

    if (typeof callback === 'function') {
        callback();
    }
}
